var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeCallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0143 26.4459C33.4763 26.4446 30.9542 26.0409 28.5404 25.2497C28.1723 25.1237 27.7764 25.105 27.3981 25.1957C27.0199 25.2864 26.6747 25.4828 26.402 25.7623L23.0779 29.9706C16.7647 26.8477 11.6404 21.7226 8.49013 15.3804L12.6187 11.8345C12.8907 11.5516 13.0815 11.1996 13.171 10.8159C13.2605 10.4322 13.2452 10.0313 13.1269 9.65567C12.3325 7.22272 11.9321 4.67642 11.9412 2.11486C11.9357 1.55568 11.7131 1.02099 11.3212 0.625579C10.9293 0.230165 10.3994 0.00555982 9.84516 0H2.51955C1.37625 0 0 0.512675 0 2.11486C0.0785684 11.7274 3.89815 20.9238 10.6352 27.7212C17.3722 34.5185 26.487 38.3723 36.0143 38.4516C36.6026 38.4229 37.1556 38.1596 37.5515 37.7195C37.9474 37.2795 38.1539 36.6988 38.1255 36.1052C38.1227 36.0469 38.1176 35.9888 38.1104 35.9309V28.5607C38.1048 28.0016 37.8822 27.4669 37.4903 27.0715C37.0984 26.6761 36.5685 26.4515 36.0143 26.4459Z",
    fill: "#BAC0CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCallIcon);
export default __webpack_public_path__ + "static/media/home-call-icon.3b320b8114870f46fdaa23a7c7adb7b8.svg";
export { ForwardRef as ReactComponent };